import { render } from 'preact';
import { BUILD_VERSION } from '../shared/version';
import { Card } from './cards';
import { useState } from 'preact/hooks';
import { isRoomCode } from '../shared/protocol';
import { LocalApp } from './local';
import { OnlineRoom } from './online';
import { RulesSheet } from './rules';
import { startGamepad } from './gamepad';

function roomCodeFromPath(): string | null {
  const code = location.pathname.match(/^\/r\/([A-Za-z]+)\/?$/)?.[1]?.toUpperCase();
  return code && isRoomCode(code) ? code : null;
}

function Home() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showRules, setShowRules] = useState(false);
  async function create() {
    setBusy(true);
    setError(null);
    try {
      const res = await fetch('/api/rooms', { method: 'POST' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      location.assign(`/r/${((await res.json()) as { code: string }).code}`);
    } catch (e) {
      setError(`Couldn't create a room (${(e as Error).message}).`);
      setBusy(false);
    }
  }
  return (
    <>
      <div class="fan" aria-label="Sample hand">
        <Card card="AC" />
        <Card card="JS" />
        <Card card="BJ" />
        <Card card="3C" />
        <Card card="2C" />
      </div>
      <div class="panel">
        <p>Pitch the way Dad plays it: bid a suit, call your partner's card.</p>
        <button class="primary" data-testid="create-room" disabled={busy} onClick={create}>
          New online game
        </button>
        <a class="button secondary" href="/local" data-testid="play-local">
          Play against the computer
        </a>
        <p class="muted small">No connection needed. You can add people to share one device.</p>
        <button class="link dark" data-testid="open-rules" onClick={() => setShowRules(true)}>
          How to play
        </button>
        {error && <p class="error">{error}</p>}
      </div>
      {showRules && <RulesSheet onClose={() => setShowRules(false)} />}
    </>
  );
}

function App() {
  const local = location.pathname.replace(/\/$/, '') === '/local';
  const code = roomCodeFromPath();
  return (
    <>
      <h1>
        <a href="/">Corwin's Call Your Partner</a>
      </h1>
      {local ? <LocalApp /> : code ? <OnlineRoom code={code} /> : <Home />}
      <div class="watermark">{BUILD_VERSION}</div>
    </>
  );
}

render(<App />, document.getElementById('app')!);
startGamepad();
